export enum EntityType {
    Individual = 'Individual',
    Lender = 'Lender',
    RealEstateAgent = 'RealEstateAgent',
    Trust = 'Trust',
    Estate = 'Estate',
    Attorney = 'Attorney',
    TitleCompany = 'TitleCompany',
    LawFirm = 'LawFirm',
    Corporation = 'Corporation',
    Llc = 'Llc',
    Builder = 'Builder',
    GeneralContractor = 'GeneralContractor',
    Other = 'Other',
    RealEstateBrokerage = 'RealEstateBrokerage',
    Exchange1031 = 'Exchange1031',
}
